import EdoTransactions from './EdoTransactions';

export default EdoTransactions;
